import React from 'react';
import clsx from 'clsx';

import LoadingIcon from './LoadingIcon';

import styles from './Button.module.scss';

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  className?: string;
  color?: 'blue' | 'grey' | 'white' | 'blue-light' | 'grey-light' | 'red' | 'green';
  fullWidth?: boolean;
  loading?: boolean;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  size?: 'small' | 'medium' | 'large' | 'extra-large';
  startIcon?: React.ReactNode;
  variant?: 'contained' | 'outlined';
}

const Button: React.FC<ButtonProps> = ({
  children,
  className,
  color = 'blue',
  fullWidth = false,
  loading = false,
  onClick = undefined,
  size = 'medium',
  startIcon: StartIcon,
  variant = 'contained',
  ...rest
}) => (
  <button
    type="button"
    className={clsx(
      styles.button,
      styles[color],
      styles[size],
      styles[variant],
      { [styles.fullWidth]: fullWidth },
      className
    )}
    onClick={onClick}
    {...rest}
  >
    {loading && <LoadingIcon />}
    {StartIcon || null}
    {children}
  </button>
);

export default Button;
